'use client';

import { FunctionComponent, memo, PropsWithChildren } from 'react';
import { useUnit } from 'effector-react';
import { getClientScope } from '@effector/next';
import { attachReduxDevTools } from '@effector/redux-devtools-adapter';
import { effectorStartEvent } from '@nx-frontend/shared/store/client-side';

const clientScope = getClientScope();
if (clientScope) {
  attachReduxDevTools({
    scope: clientScope,
    name: 'portals',
    stateTab: true,
    trace: true,
  });
}

let initialized = false;

const Component: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const effectorStart = useUnit(effectorStartEvent);
  // Due to ReactStrict mode this component renders twice. This is a workaround for one effectorStartEffect call
  if (!initialized) {
    effectorStart();
    initialized = true;
  }
  return children;
};

export const ReduxDevToolsAdapter = memo(Component);
